// extracted by mini-css-extract-plugin
module.exports = {"icon":"ChildFeedbackDisplayList_icon__1yEj5","list":"ChildFeedbackDisplayList_list__qO7Zz"};